import { ROOT_CATEGORY_ID } from "./normalizers/constants";
import { normalizeParentQuantity } from "./normalizers/normalizeParentQuantity";
import { normalizeQuantity } from "./normalizers/normalizeQuantity";

export function normalizeAdminSnapshot(data) {
  const categoriesById = {};
  const categoriesByNodeId = {};
  const quantitiesById = {};
  const categoryIds = []; // Add this to track order

  const categories = Array.isArray(data)
  ? data
    : data?.categories || [];

  for (const category of categories) {
    // console.log('now: caids: ', category)
    const isRoot = category.id == null;

    const categoryId = isRoot ? ROOT_CATEGORY_ID : category.id;
    const categoryTitle = isRoot ? 'بدون دسته بندی' : category.title;

    categoryIds.push(categoryId); // Store ID in order

    const categoryNode = {
      id: categoryId,
      nodeId: isRoot ? ROOT_CATEGORY_ID : `c${category.id}`,
      code: category.code,
      title: categoryTitle,
      type: 'category',
      isActive: category.is_active ?? true,
      orderNumber: category.order_number ?? 9999,
      parents: [],
      direct: [],
    };

    for (const parent of category.parents || []) {
      const pNode = {...normalizeParentQuantity(parent),
        type: 'parent',
        canEditPrice: true,
      }   
      quantitiesById[`p${parent.id}`] = pNode;

      for (const q of parent.quantity_definitions || []) {
        const qNode = {...normalizeQuantity(q),
          type: "quantity",
          canEditPrice: false,
          nodeId: `q${q.id}`,
        };

        quantitiesById[`q${q.id}`] = qNode;
        pNode.quantityDefinitions.push(qNode);
      }

      categoryNode.parents.push(pNode);
    }

    for (const q of category.direct_quantities || []) {
        const qNode = {...normalizeQuantity(q),
          type: "direct",
          canEditPrice: true,
          nodeId: `q${q.id}`,
        };
        quantitiesById[`q${q.id}`] = qNode;
        categoryNode.direct.push(qNode);
    }
    
    categoriesById[categoryId] = categoryNode;
  }

  return {
    categoriesById,
    quantitiesById,
    categoryIds,
  };
}